import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import { Typography } from 'rmwc';
import { Text } from '../../components/Text';
import { SliderControl } from '../../components/controls/SliderControl';
import { SelectControl } from '../../components/controls/SelectControl';

import { fetchGuaranteedIncome, fetchSpendingSourcesGuaranteedIncome } from '../../actions/wealthManagementActions';

export const SliderWidget = ({ ...sliderProps }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <div style={{ width: '80%', margin: 'auto' }}>
        <SliderControl {...sliderProps} discrete />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Text className="p-0" use="body1">
          {sliderProps.minLabel}
        </Text>
        <Text className="p-0" use="body1">
          {sliderProps.maxLabel}
        </Text>
      </div>
    </div>
  );
};

export class GuaranteedIncomeAssumptions extends Component {
  constructor(props) {
    super(props);
  }

  onChange = (type, evt) => {
    this.props.onChange(type, evt.detail.value);
  };

  render() {
    return (
      <Fragment>
        <div>
          <Text use="subtitle1" className="mt-1 mb-1">
            Market volatility
          </Text>
          <Text use="body1" theme="text-secondary-on-background" className="mt-0 mb-1">
            A market recession could wipe out your savings, but will never affect guaranteed income.
          </Text>
          <div className="hrbr-form">
            <SelectControl
              label="Financial Shock"
              value={this.props.financialShock}
              spec={{
                options: ['none', 'recession2'],
                option_data: {
                  none: { label: 'Normal' },
                  recession2: { label: 'Recession' },
                },
              }}
              onChange={evt => this.onChange('financialShock', evt)}
            />
          </div>
        </div>
        <div style={{ borderTop: '1px solid #e0e0e0', margin: '1rem -15px' }} />
        <div className="pb-2">
          <Text use="subtitle1" className="mt-1 mb-1">
            Living a long time
          </Text>
          <Text use="body1" theme="text-secondary-on-background" className="mt-0">
            If you live to be 100, you could run out savings. But your guaranteed income will never stop.
          </Text>
          <SliderControl
            minLabel="Age 80"
            maxLabel="Age 100"
            value={this.props.planToAge}
            spec={{
              field_type: 'range',
              min: 80,
              max: 100,
              step_size: 1,
              _default: 93,
            }}
            valueFormatter={val => `Planning until: Age ${val}`}
            onChange={e => this.onChange('planToAge', e)}
            onInput={e => this.onChange('planToAge', e)}
            persistentPin
            discrete
          />
        </div>
      </Fragment>
    );
  }
}

const mapDispatchToProps = {};

export default connect(null, mapDispatchToProps)(GuaranteedIncomeAssumptions);
